

























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ToggleView extends Vue {
  @Prop() cardView!: string;

  view = this.cardView;

  emitCardView(view: string) {
    this.view = view;
    this.$emit('toggle-card-view', view);
  }
}
